<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="country-landing-section inner-home">
  <div class="container maxWidth540">
    <div class="col-6 col-sm-2 mt-4 position-absolute" style="z-index:1"><a><button class="btn btn-primary btn-back top-back-button" (click)="back()" ><i
      class="fa fa-chevron-left text-left"></i> Back</button></a></div>

    <div class="row no-margin">
      <div class="col-12 col-sm-8 col-md-8 text-center m-auto">
        
        <div class="mt-5 mb-4 orange-logo">
          <img
            src="{{globalService.externalResourcesUrl}}{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.agencySealFileName}}"
            class="img-fluid">
        </div>
      </div>
      <div style="width:100%"></div>
      <div class="col-12 col-sm-8 col-md-8 text-center m-auto searchContainer">
        <div class="taxCollectorName">{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.taxCollectorName}}
        </div>
        <div class="countyName">{{(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.name}} Tax Collector
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
          {{errorMessage}}
        </div>

        <a>
          <button class="btn btn-primary btn-commonbtn" (click)="dmvRenewal()"><img
              src="{{globalService.staticResourceURL}}assets/images/header-image-car.svg"
              class="img-fluid country-img">DMV Tag Renewal</button>
        </a>
        <!--
        <a>
          <button class="btn btn-primary  btn-commonbtn disabled"><img
              src="{{globalService.staticResourceURL}}assets/images/header-image-house.svg"
              class="img-fluid country-img">Pay Property Tax
            <span class="comingSoon">Coming soon!</span></button>
        </a>

        <a>
          <button class="btn btn-primary  btn-commonbtn disabled"><img
              src="{{globalService.staticResourceURL}}assets/images/header-image-business.svg"
              class="img-fluid country-img">Pay Business Tax
            <span class="comingSoon">Coming soon!</span></button>
        </a>
        -->

      </div>
    </div>
  </div>
</div>